import { render, staticRenderFns } from "./heroHomepageGalleryV2.vue?vue&type=template&id=912e38ca&"
import script from "./heroHomepageGalleryV2.vue?vue&type=script&lang=js&"
export * from "./heroHomepageGalleryV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/one-stop-shop/one-stop-shop/one-stop-shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('912e38ca')) {
      api.createRecord('912e38ca', component.options)
    } else {
      api.reload('912e38ca', component.options)
    }
    module.hot.accept("./heroHomepageGalleryV2.vue?vue&type=template&id=912e38ca&", function () {
      api.rerender('912e38ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/wp-content/themes/global-theme/views/blocks/heroHomepage/heroHomepageGalleryV2.vue"
export default component.exports